// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./NumericInput";
export type { NumericInputProps } from "./NumericInput";
